module.exports = __webpack_public_path__ + "img/wireframes.88423143.png";